// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Badge,
    Chip
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useSearchParams, useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import apiUrl from '../../../configs/constant';

import LinearProgress from '@mui/material/LinearProgress'

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Avatar from '@mui/material/Avatar'
import TabContext from '@mui/lab/TabContext'

// Styled Grid component
const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        order: -1,
        display: 'flex',
        justifyContent: 'center'
    }
}))

// Styled component for the image
const Img = styled('img')(({ theme }) => ({
    right: 0,
    bottom: 8,
    width: 100,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
        width: 200,
        position: 'static'
    }
}))

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const [searchParams] = useSearchParams();
    const menu = searchParams.get('menu');
    const sysdoctag_id = searchParams.get('sysdoctag_id');
    const doc_name = searchParams.get('doc_name');

    // ** State
    const [loading, setLoading] = useState<boolean>(false)
    const [pageSize, setPageSize] = useState<number>(10)
    const [filteredData, setFilteredData] = useState<any[]>([])
    const [listData, setListData] = useState<any[]>([])

    const [value, setValue] = useState<any>('')
    const [listMenu, setListMenu] = useState<any[]>([])
    const [listOtorisasi, setListOtorisasi] = useState<any[]>([])
    const [listOtorisasiFilter, setListOtorisasiFilter] = useState<any[]>([])
    const [loadingMenu, setLoadingMenu] = useState<boolean>(false)
    const [selectedDoctag, setSelectedDoctag] = useState<any>('')
    const [selectedDocId, setSelectedDocId] = useState<any>('')
    const [selectedTrans, setSelectedTrans] = useState<any[]>([])

    const [header, setHeader] = useState<any[]>([])

    const navigate = useNavigate();

    useEffect(() => {
        const getData = () => {
            setLoadingMenu(true)
            const url = apiUrl.apiUrl + '/system/dokumen/list-otorisasi'
            axios
                .get(url, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    response.data.data_menu.forEach((element: any, index: any) => {
                        if (index == 0) {
                            if (menu != null && sysdoctag_id != null && doc_name != null) {
                                setValue(menu)
                                let otoFilter: any[] = []
                                response.data.data.forEach((el: any) => {
                                    if (el.menu == menu) {
                                        otoFilter.push(el)
                                    }
                                })
                                setListOtorisasiFilter(otoFilter)
                                getOtorisasiData(sysdoctag_id)
                                setSelectedDoctag(doc_name)
                                setSelectedDocId(sysdoctag_id)
                                setValue(menu)
                            } else {
                                setValue(element.menu)
                                let otoFilter: any[] = []
                                response.data.data.forEach((el: any) => {
                                    if (el.menu == element.menu) {
                                        otoFilter.push(el)
                                    }
                                })
                                setListOtorisasiFilter(otoFilter)
                            }
                        }
                    })
                    setListMenu(response.data.data_menu)
                    setListOtorisasi(response.data.data)
                    setLoadingMenu(false)
                })
        }

        getData()
    }, [])


    const getOtorisasiData = (param: any) => {
        const url = apiUrl.apiUrl + '/system/dokumen/list-transaksi-otorisasi?sysdoctag_id=' + param
        setLoading(true)
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                const data = response.data.data
                setListData(data)
                setFilteredData(data)
                setLoading(false)
            })
    }

    interface RenderTabAvatarProps {
        category: string;
        icon: string;
        jumlah: number;
    }

    const RenderTabAvatar = ({ category, icon, jumlah }: RenderTabAvatarProps) => {
        return (
            <Badge badgeContent={jumlah} color='info' key={category}>
                <Avatar
                    variant='rounded'
                    sx={{
                        width: 100,
                        height: 92,
                        backgroundColor: 'transparent',
                        border: theme =>
                            value === category ? `2px solid ${theme.palette.primary.main}` : `2px dashed ${theme.palette.divider}`
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        {icon != '' ? <Icon icon={icon} /> : <Icon icon='mdi:circle' />}
                        <Typography
                            variant='body2'
                            sx={{ mt: 2, fontWeight: 600, color: 'text.primary', textTransform: 'capitalize' }}
                        >
                            {category}
                        </Typography>
                    </Box>
                </Avatar>
            </Badge>
        )
    }

    interface OtorisasiData {
        jumlah: number;
        sysdoctag_id: string;
        oto_link?: string | null;
        doctag: string;
    }

    const RenderTabContent = ({ data }: { data: OtorisasiData[] }) => {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'center' }}>
                {data.map((row: OtorisasiData, index: number) => (
                    <Badge badgeContent={row.jumlah} color='primary' sx={{ mr: 3 }} key={row.sysdoctag_id}>
                        {row.oto_link != null && !row.oto_link.includes('bekerjadenganhati.com') ? (
                            <Chip
                                label={row.doctag}
                                color='primary'
                                onClick={e => {
                                    if (row.oto_link) {
                                        navigate(row.oto_link)
                                    }
                                }}
                            />
                        ) : (
                            <Chip
                                label={row.doctag}
                                color='primary'
                                onClick={e => {
                                    if (row.oto_link != null) {
                                        window.open(row.oto_link, '_blank')
                                    } else {
                                        setSelectedDoctag(row.doctag)
                                        getOtorisasiData(row.sysdoctag_id)
                                        setSelectedDocId(row.sysdoctag_id)
                                    }
                                }}
                            />
                        )}
                    </Badge>
                ))}
            </Box>
        )
    }

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue)
        let otoFilter: any[] = []
        listOtorisasi.forEach(element => {
            if (element.menu == newValue) {
                otoFilter.push(element)
            }
        })
        setListOtorisasiFilter(otoFilter)
    }

    const otoChecked = () => {
        let data = {
            transaksi: '',
            sysdoctag_id: ''
        }

        data.transaksi = JSON.stringify(selectedTrans)
        data.sysdoctag_id = String(selectedDocId)
        let formdata = data

        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/system/dokumen/otorisasi-bulk'
        axios
            .post(url, formdata, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'success',
                        timer: 1000,
                        timerProgressBar: true,
                        willClose: () => {
                            window.location.reload();
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        html: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Pemberitahuan',
                    text: error.message,
                    icon: 'error'
                })
            })
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='DASHBOARD OTORISASI' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        </Box>
                    </Box>
                    <Divider />

                    {loadingMenu ? (
                        <Grid sx={{ p: 5 }}>
                            <LinearProgress />
                        </Grid>
                    ) : (
                        <TabContext value={value}>
                            <TabList
                                variant='scrollable'
                                scrollButtons='auto'
                                onChange={handleChange}
                                sx={{
                                    mb: 2.5,
                                    px: 5,
                                    '& .MuiTab-root:not(:last-child)': { mr: 4 },
                                    '& .MuiTabs-indicator': { display: 'none' }
                                }}
                            >
                                {listMenu.map(el => (
                                    <Tab
                                        value={el.menu}
                                        key={el.menu}
                                        sx={{ pl: 0, pr: 3 }}
                                        label={<RenderTabAvatar category={el.menu} icon={el.icon} jumlah={el.jumlah} />}
                                    />
                                ))}
                            </TabList>

                            {listMenu.map(el => (
                                <TabPanel sx={{ p: 0, mb: 2.5 }} value={el.menu} key={el.menu}>
                                    <RenderTabContent data={listOtorisasiFilter} />
                                </TabPanel>
                            ))}
                        </TabContext>
                    )}

                    {selectedTrans.length > 0 ? (
                        <Box
                            sx={{
                                gap: 2,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                p: theme => theme.spacing(2, 5, 4, 5)
                            }}
                        >
                            <Button
                                sx={{ marginTop: 2, marginLeft: 3, marginRight: 3 }}
                                variant='contained'
                                color='info'
                                onClick={otoChecked}
                                startIcon={<Icon icon='mdi:text-box-check-outline' />}
                            >
                                Otorisasi Checked
                            </Button>
                        </Box>
                    ) : null}

                    {listData.length > 0 ? (
                        <Grid item xs={12} sm={12} sx={{ mt: 5 }}>
                            <MsiDatagrid array={listData} />
                        </Grid>
                    ) : null}
                </div>
            </Grid>
        </Grid>
    )
}
